const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaODataSelectCtrl = function($scope, $routeParams, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  if (vm.data) {
    refreshData(vm.data);
  }

  vm.refreshData = refreshData;

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  function refreshData(userSearch) {
    if (!userSearch) return;

    dataService.search({
      endpoint: vm.settings.endpoint,
      searchTerm: userSearch
    })
      .then((data) => {
        vm.searchResults = data;
      })
      .catch(() => {

      });
  }
};

lbaODataSelectCtrl.$inject = $inject;

export default lbaODataSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaODataSelect/lbaODataSelectCtrl.js